var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "text-left" }, [
    _c(
      "label",
      {
        staticClass: "pdf-drop",
        class: {
          "pdf-drop--over": _vm.over,
          "pdf-drop--error": _vm.error,
          "pdf-drop--multiple": _vm.multiple,
        },
        on: {
          dragover: function ($event) {
            $event.preventDefault()
            _vm.over = true
          },
          dragleave: function ($event) {
            $event.preventDefault()
            _vm.over = false
          },
          drop: function ($event) {
            $event.preventDefault()
            return _vm.onDrop.apply(null, arguments)
          },
        },
      },
      [
        _c("input", {
          ref: "input",
          staticClass: "pdf-drop__input",
          attrs: {
            type: "file",
            accept: "application/pdf,.pdf",
            multiple: _vm.multiple,
          },
          on: { change: _vm.onPick },
        }),
        !_vm.multiple && _vm.value
          ? [
              _c("v-icon", { attrs: { color: "#a8201a" } }, [
                _vm._v("mdi-file-pdf-box"),
              ]),
              _c("span", { staticClass: "pdf-drop__name" }, [
                _vm._v(_vm._s(_vm.value.name)),
              ]),
              _c(
                "v-btn",
                {
                  attrs: {
                    icon: "",
                    small: "",
                    "aria-label": "Quitar archivo",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.$emit("input", null)
                    },
                  },
                },
                [_c("v-icon", { attrs: { small: "" } }, [_vm._v("mdi-close")])],
                1
              ),
            ]
          : [
              _c("v-icon", { attrs: { color: "#1f6f78" } }, [
                _vm._v(
                  _vm._s(_vm.multiple ? "mdi-tray-arrow-up" : "mdi-paperclip")
                ),
              ]),
              _c("span", { staticClass: "pdf-drop__text" }, [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.multiple ? "Elegí los PDF" : "Elegí un PDF")
                  ),
                ]),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.multiple
                        ? "o arrastralos todos juntos acá"
                        : "o arrastralo acá"
                    ) +
                    " "
                ),
              ]),
              _vm.hint
                ? _c("span", { staticClass: "pdf-drop__hint" }, [
                    _vm._v(_vm._s(_vm.hint)),
                  ])
                : _vm._e(),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }